import React, { useEffect, useState, memo } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { baseURL, token } from '../../token';
import axios from 'axios';
import HeaderComponent from '../HeaderComponent';
import acceptSound from "./accept.mp3";
import playSound from "./play.mp3";
import findGif from "../../styles/loading_old.gif";

// import Logo from '../styles/logo.png'

const Openbattles = React.memo(({ key, allgame, user, deleteChallenge, getPost, RejectGame, winnAmount, AcceptChallang, updateChallenge }) => {
    // const navigate = useNavigate();
    // const [messageError, setMessageError] = useState('');
    // const [commission, setCommision] = useState(0);
    // const [isLoading, setIsLoading] = useState(false);

    // const handleplaybtn = async (id, price, roomcode, challengeid) => {
    //     setMessageError('');
    //     try {
    //         // navigate('/EnterFirstGame')
    //         setIsLoading(true);
    //         console.log(id);
    //         const requestbody = {
    //             challengeId: id
    //         }
    //         const accessToken = localStorage.getItem('access_token'); // Retrieve access token from localStorage
    //         // console.log(accessToken);
    //         const headers = accessToken ? { Authorization: `Bearer ${accessToken}` } : {};

    //         const response = await axios.post(baseURL + '/challenge/accept', requestbody, {
    //             headers: headers
    //         });
    //         fetchData();
    //         setMessageError('')
    //         console.log(response);
    //         setIsLoading(false);
    //         if (response) {
    //             <HeaderComponent />
    //             navigate('/EnterFirstGame', { state: { challengeruserid: challengeid, priceplay: price, roomcode: roomcode, type: "openbattle" } });
    //         }
    //     } catch (error) {
    //         setMessageError(error?.response?.data?.message);
    //         console.error("error:--", error?.response?.data?.message);
    //         setIsLoading(false);
    //     }
    // }
    // const handlecancelbtn = async (id) => {
    //     setMessageError('');
    //     try {
    //         console.log(id);
    //         setIsLoading(true);
    //         const accessToken = localStorage.getItem('access_token'); // Retrieve access token from localStorage
    //         // console.log(accessToken);
    //         const headers = accessToken ? { Authorization: `Bearer ${accessToken}` } : {};
    //         console.log(headers);
    //         const response = await axios.delete(`${baseURL}/challenge/${id}`, {
    //             headers: headers
    //         });
    //         fetchData();
    //         console.log(response);
    //         setIsLoading(false);
    //         // if (response) {
    //         //     navigate('EnterFirstGame')
    //         // }
    //     } catch (error) {
    //         setMessageError(error?.response?.data?.message);
    //         console.error("error:--", error);
    //         setIsLoading(false);
    //     }
    // }

    // const fetchpenalty = async () => {
    //     console.log("ahdfnjm");
    //     try {
    //         const accessToken = localStorage.getItem('access_token'); // Retrieve access token from localStorage
    //         const headers = accessToken ? { Authorization: `Bearer ${accessToken}` } : {};

    //         const response = await axios.get(baseURL + '/user/penalties', {
    //             headers: headers
    //         });
    //         console.log("responseee", response);
    //         console.log(response?.data?.data?.id, "response");
    //         setCommision(response?.data?.data?.commission);
    //     } catch (error) {
    //         console.error(error);
    //     }
    // };
    // useEffect(() => {
    //     fetchpenalty();
    // }, [])
    return (
        <div className="col-12 card my-1 walletcard pt-2 px-0 mx-auto text-white" key={key}>
            <div className="row">
                <div className="col d-flex justify-content-between " >
                    <span className="mx-2 text-black" style={{ fontSize: '13px', fontWeight: '600' }}>Challenge set by  </span>
                    {/* <h6 className="mx-2">{battle.roomcode}</h6> */}
                    <div className="d-flex align-items-start mr-2" style={{ gap: '12px' }}>
                        <div className="text-end" style={{ minWidth: '76px' }}>
                            <p className="mb-0 text-black" id="win-time" style={{ fontSize: '11px', fontWeight: '600', lineHeight: 1.1, whiteSpace: 'nowrap' }}>Entry Fee</p>
                            <h6 className="mb-0 text-success" style={{ fontSize: '14px', fontWeight: '700', lineHeight: 1.15, whiteSpace: 'nowrap' }}>
                                Rs {allgame.Game_Ammount}
                            </h6>
                        </div>
                        <div className="text-end" style={{ minWidth: '76px' }}>
                            <p className="mb-0 text-black" id="win-time" style={{ fontSize: '11px', fontWeight: '600', lineHeight: 1.1, whiteSpace: 'nowrap' }}>Prize</p>
                            <h6 className="mb-0 text-success" style={{ fontSize: '14px', fontWeight: '700', lineHeight: 1.15, whiteSpace: 'nowrap' }}>
                                Rs {allgame.Game_Ammount + winnAmount(allgame.Game_Ammount)}
                            </h6>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card-body walletbody mt-2">
                <div className="row">
                    {/* {isLoading && <p>Loading...</p>} */}
                    <div className="col-12 d-flex justify-content-between align-items-center flex-wrap" style={{ gap: '10px' }}>
                        <div className="d-flex">
                            <div className="ms-2">
                                <h6 className="mb-0 d-flex text-black" style={{ textTransform: "capitalize" }}>
                                    <span className="material-symbols-outlined me-1" style={{ fontSize: '18px' }}>person</span>
                                    {allgame.Created_by.Name}
                                </h6>
                            </div>
                        </div>

                        {user == allgame.Created_by._id &&
                            allgame.Status == "requested" && (<>
                                <div>
                                    <Link to={{ pathname: `/viewgame/${allgame._id}`, state: { prevPath: window.location.pathname } }} onClick={(e) => getPost(allgame._id)} style={{ bottom: '0' }}>
                                        <button
                                            style={{ width: '80px', height: '29px', fontSize: '11px', fontWeight: '600' }}
                                            className={`btn bg-red ml-2 mt-2`}
                                        >
                                            START
                                        </button>
                                    </Link>
                                    {/* <button
                                    style={{width: '80px', height: '37px'}} className="btn bg-orange" onClick={() => handleplaybtn(battle.id, battle.price, battle.roomcode, battle.challenger)} disabled={isLoading} >Play</button> */}
                                    {/* <button className="btn bg-orange" onClick={handlePlaybtn}>Play</button> */}
                                </div>
                                <div>
                                    <button
                                        className={`btn bg-blue ml-2 mt-2`}
                                        style={{ width: '80px', height: '29px', fontSize: '11px', fontWeight: '600' }}
                                        onClick={() => RejectGame(allgame._id)}
                                    >
                                        REJECT
                                    </button>
                                    {/* <button className="btn bg-orange" disabled={isLoading} onClick={() => handlecancelbtn(battle.id)} >Cancel</button> */}
                                    {/* <button className="btn bg-orange" onClick={handlePlaybtn}>Play</button> */}
                                </div>
                            </>)}

                        {user !== allgame.Created_by._id &&
                            allgame.Status == "new" && (
                                <button
                                    style={{ width: '80px', height: '37px' }}
                                    className={`btn bg-red`}
                                    onClick={() => AcceptChallang(allgame._id)}
                                >
                                    Play
                                </button>
                            )}
                        {/* {user == allgame.Accepetd_By._id && allgame.Status == 'running' && <button
                        style={{width: '80px', height: '37px'}} className={`${css.bgSecondary} ${css.playButton} ${css.cxy}`} >start</button>} */}
                        {user == allgame.Created_by._id &&
                            allgame.Status == "new" && (
                                <div className="d-flex align-items-center ml-auto" style={{ gap: '10px' }}>
                                    <div
                                        className="d-flex align-items-center"
                                        style={{ background: '#f3f5f7', borderRadius: '10px', padding: '8px 10px', minWidth: '190px' }}
                                    >
                                        <img src={findGif} style={{ width: '22px', height: '22px', marginRight: '8px' }} />
                                        <div style={{ lineHeight: 1.1 }}>
                                            <span className="text-dark" style={{ fontSize: '14px', fontWeight: '600' }}>
                                                Finding Player...
                                            </span>
                                            <div className="text-muted" style={{ fontSize: '11px' }}>
                                                Waiting for opponent
                                            </div>
                                        </div>
                                    </div>
                                    <button
                                        style={{ width: '90px', height: '34px', fontSize: '11px', fontWeight: '700' }}
                                        className={`btn bg-blue`}
                                        onClick={() => deleteChallenge(allgame._id)}
                                    >
                                        DELETE
                                    </button>
                                </div>
                            )}
                        {user !== allgame.Created_by._id &&
                            allgame.Status == "requested" && (
                                <div className="d-flex ml-auto align-items-center">
                                    <div
                                        className={`btn bg-green position-relative mx-1 text-white btn-sm`}
                                    >
                                        requested
                                    </div>
                                    <button
                                        style={{ width: '80px', height: '30px' }}
                                        className={`btn bg-red position-relative mx-1 bg-danger btn-sm`}
                                        onClick={() => RejectGame(allgame._id)}
                                    >
                                        cancel
                                    </button>
                                </div>
                            )}
                        {(user == allgame.Created_by._id || user == allgame.Accepetd_By?._id) &&
                            allgame.Status == "running" && (

                                <div className="d-flex ml-auto align-items-center">
                                    <audio src={playSound} autoPlay>
                                    </audio>
                                    <Link
                                        className={`btn bg-orange bg-success btn-sm'`}
                                        to={{ pathname: `/viewgame/${allgame._id}`, state: { prevPath: window.location.pathname } }}
                                        onClick={(e) => updateChallenge(allgame._id)}
                                    >
                                        click for room code
                                    </Link>
                                </div>
                            )}
                        {user == allgame.Created_by._id &&
                            allgame.Status == "requested" && (
                                <div className="d-flex ml-auto align-items-center mr-5 mt-1">
                                    <audio src={acceptSound} autoPlay>
                                    </audio>

                                    {/* <div className="text-center" style={{width: '115px'}}> */}
                                        {/* <div className="pl-2"> */}
                                            {allgame.Accepetd_By.avatar ? (<img
                                                src={baseURL + `${allgame.Accepetd_By.avatar}`}
                                                alt=""
                                                width='40px' height="40px"
                                                style={{ borderTopLeftRadius: "50%", borderTopRightRadius: "50%", borderBottomRightRadius: "50%", borderBottomLeftRadius: "50%" }}
                                            />) : (<img
                                                // src={`https://png.pngtree.com/png-clipart/20211103/ourmid/pngtree-chessboard-four-person-game-color-png-image_4013567.png`}
                                                alt=""
                                                width='40px' height="40px"
                                                style={{ borderTopLeftRadius: "50%", borderTopRightRadius: "50%", borderBottomRightRadius: "50%", borderBottomLeftRadius: "50%" }}
                                            />)}
                                        {/* </div> */}
                                        {/* <div style={{ lineHeight: 1 }}> */}
                                            <span className={''}>
                                                &nbsp;&nbsp;{allgame.Accepetd_By.Name.slice(0, 6)}
                                            </span>
                                        {/* </div> */}
                                    {/* </div> */}
                                </div>
                            )}

                    </div>
                </div>
            </div>
        </div>
    )
})

export default memo(Openbattles)
